import FeedbackModal from '@/common/ui/modals/FeedbackModal';
import { HandWavingIcon } from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import { useState } from 'react';

interface GiveFeedbackButtonProps {
  requireEmail?: boolean;
}

export default function GiveFeedbackButton({
  requireEmail = false,
}: GiveFeedbackButtonProps) {
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  return (
    <>
      <Button variant="outline" onClick={() => setFeedbackModalOpen(true)}>
        <HandWavingIcon size={16} className="mr-2" />
        Give Feedback
      </Button>

      <FeedbackModal
        isOpen={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
        requireEmail={requireEmail}
      />
    </>
  );
}
